module.exports = __webpack_public_path__ + "img/w3w-circle.e1d8f964.png";